import { API } from '../configs/axios/axios.config'

const GET_STARTER_CODE_ENDPOINT = token => `/unit-tests/${token}/starter-code`
const SUBMIT_INSTANT_FEEDBACK_ENDPOINT = token => `/instant-feedback/${token}/submit`
const CHECK_STUDENT_SUBMISSION_ENDPOINT = token => `/instant-feedback/${token}/check-student-submission`
const GET_EXISTING_FEEDBACK_ENDPOINT = token => `/instant-feedback/${token}/get-existing-feedback`
const CREATE_ASSIGNMENT_STUDENT_FEEDBACK_ENDPOINT = `/assignment-feedback`
const GET_ASSIGNMENT_STUDENT_FEEDBACK_ENDPOINT = token => `/assignment-feedback/${token}/by-assignment`
const UPDATE_ASSIGNMENT_STUDENT_FEEDBACK_ENDPOINT = id => `/assignment-feedback/${id}`
const RECORD_METRICS_ENDPOINT = token => `/patterns/${token}/record-metrics`

class _InstantFeedbackService {
    getStarterCode(token, userId, instantFeedbackType) {
        return API.get(GET_STARTER_CODE_ENDPOINT(token), {
            timeout: 8000,
            params: {
                instant_feedback_type: instantFeedbackType,
                ...(userId !== undefined && { user_id: userId }),
            },
        })
    }

    submitSolution(token, solution, submissionToken, timeout) {
        return API.post(
            SUBMIT_INSTANT_FEEDBACK_ENDPOINT(token),
            {
                solution,
                submission_token: submissionToken,
            },
            {
                timeout,
            },
        )
    }

    getExistingFeedback(token, file_token) {
        return API.post(
            GET_EXISTING_FEEDBACK_ENDPOINT(token),
            {
                file_token: file_token,
            },
            {
                timeout: 15000,
            },
        )
    }

    checkStudentSubmission(token, studentId, classId) {
        return API.post(
            CHECK_STUDENT_SUBMISSION_ENDPOINT(token),
            {
                student_id: studentId,
                class_id: classId,
            },
            {
                timeout: 15000,
            },
        )
    }

    createAssignmentStudentFeedback(token, userId, liked) {
        return API.post(
            CREATE_ASSIGNMENT_STUDENT_FEEDBACK_ENDPOINT,
            {
                user_id: userId,
                liked,
            },
            {
                params: {
                    assignment_token: token,
                },
            },
        )
    }

    updateAssignmentStudentFeedback(id, feedback) {
        return API.patch(UPDATE_ASSIGNMENT_STUDENT_FEEDBACK_ENDPOINT(id), { feedback })
    }

    getAssignmentStudentsFeedback(token) {
        return API.get(GET_ASSIGNMENT_STUDENT_FEEDBACK_ENDPOINT(token))
    }

    recordPatternMetrics(token, fileId, actedPatterns) {
        return API.put(RECORD_METRICS_ENDPOINT(token), {
            acted_patterns: actedPatterns,
            file_id: fileId,
        })
    }
}

const InstantFeedbackService = new _InstantFeedbackService()
export default InstantFeedbackService
